export default function (state, val) {
  let ag = state.list.filter(i => {
    return i.code === val.AgreementCode;
  })[0];
  let contragents = [],
    legals = [],
    requests = [];
  if (val.cType === 1) {
    let inp = Math.ceil((val.PaymentsData.ClientDebt) * 100) / 100;
    let out = Math.ceil((val.PaymentsData.ClientPayed) * 100) / 100;
    requests.push({
      code: val.AgreementCode,
      type: 1,
      contragent: val.cId,
      key: '1_' + val.cId + '_0',
      legal: 0,
      name: '',
      sum: 0,
      bonus: val.BonusesData.CanPayWithBonuses ? val.BonusesData.MaxPayment : 0,
      value: 0,
      course: val.ClientContractorsData.Contragents[0].Course,
      currency: val.PaymentsData.AgreementCurrencyId,
      AGCurrency: val.PaymentsData.AgreementCurrencyId,
      inp: inp > 0 ? inp : 0,
      out: out > 0 ? out : 0,
      operatorId: val.PartnerContractorsData.Contragents.length ? val.PartnerContractorsData.Contragents[0].Id : '',
    });
    contragents.push({
      type: 1,
      value: val.cId,
      label: val.cName,
      legalId: 0,
      allow: false,
      hiddenClient: false,
      hiddenOperator: false,
    });
    legals.push({
      type: 1,
      contragent: val.cId,
      value: 0,
      label: '',
    });
  }
  if (val.cType === 2) {
    let inp = Math.ceil((val.PaymentsData.ClientDebt) * 100) / 100;
    let out = Math.ceil((val.PaymentsData.ClientPayed) * 100) / 100;
    requests.push({
      code: val.AgreementCode,
      type: 2,
      contragent: val.cId,
      key: '1_' + val.cId + '_0',
      legal: val.cLegalId,
      name: '',
      sum: 0,
      bonus: val.BonusesData.CanPayWithBonuses ? val.BonusesData.MaxPayment : 0,
      value: 0,
      course: val.ClientContractorsData.Contragents[0].Course,
      currency: val.PaymentsData.AgreementCurrencyId,
      AGCurrency: val.PaymentsData.AgreementCurrencyId,
      inp: inp > 0 ? inp : 0,
      out: out > 0 ? out : 0,
      operatorId: val.PartnerContractorsData.Contragents.length ? val.PartnerContractorsData.Contragents[0].Id : '',
    });
    contragents.push({
      type: 2,
      value: val.cId,
      label: val.cName,
      legalId: val.cLegalId,
      allow: false,
    });
    legals.push({
      type: 2,
      contragent: val.cId,
      value: val.cLegalId,
      label: val.cLegalName,
    });
  }
  //Добавляем контрагентов
  val.ClientContractorsData.Contragents.forEach(i => {
    contragents.push({
      type: 1,
      value: i.Id,
      label: i.Name,
      legalId: 0,
      allow: false,
      hiddenClient: false,
      hiddenOperator: false,
    });
    legals.push({
      type: 1,
      contragent: i.Id,
      value: 0,
      label: '',
    });
    let inp = Math.ceil((val.PaymentsData.ClientDebt) * 100) / 100;
    let out = Math.ceil((val.PaymentsData.ClientPayed) * 100) / 100;
    requests.push({
      code: val.AgreementCode,
      type: 1,
      contragent: i.Id,
      key: '1_' + i.Id + '_0',
      legal: 0,
      name: '',
      sum: 0,
      bonus: val.BonusesData.CanPayWithBonuses ? val.BonusesData.MaxPayment : 0,
      value: 0,
      course: i.Course,
      currency: val.PaymentsData.AgreementCurrencyId,
      AGCurrency: val.PaymentsData.AgreementCurrencyId,
      inp: inp > 0 ? inp : 0,
      out: out > 0 ? out : 0,
      operatorId: val.PartnerContractorsData.Contragents.length ? val.PartnerContractorsData.Contragents[0].Id : '',
    });
  });
  val.ClientPartnerContractorsData.Contragents.forEach(i => {
    contragents.push({
      type: 2,
      value: i.Id,
      label: i.Name,
      legalId: i.LegalEntities[0].Id,
      allow: false,
      hiddenClient: false,
      hiddenOperator: false,
    });
    i.LegalEntities.forEach(ii => {
      legals.push({
        type: 2,
        contragent: i.Id,
        value: ii.Id,
        label: ii.Name,
      });
    });
    let inp = Math.ceil((val.PaymentsData.ClientDebt) * 100) / 100;
    let out = Math.ceil((val.PaymentsData.ClientPayed) * 100) / 100;
    requests.push({
      code: val.AgreementCode,
      type: 2,
      contragent: i.Id,
      legal: i.LegalEntities[0].Id,
      key: '2_' + i.Id + '_' + i.LegalEntities[0].Id,
      value: 0,
      name: '',
      sum: 0,
      bonus: 0,
      course: i.Course,
      currency: val.PaymentsData.AgreementCurrencyId,
      AGCurrency: val.PaymentsData.AgreementCurrencyId,
      inp: inp > 0 ? inp : 0,
      out: out > 0 ? out : 0,
      operatorId: val.PartnerContractorsData.Contragents.length ? val.PartnerContractorsData.Contragents[0].Id : '',
    });
  });
  val.PartnerContractorsData.Contragents.forEach(i => {
    let item1 = contragents.filter(ii => {
      return ii.type === 3 && ii.value === i.Id
    })[0];
    let item = item1;
    if (!item) {
      item = {
        type: 3,
        value: i.Id,
        label: i.Name,
        legalId: 0,
        allow: false,
      };
    }
    i.LegalEntities.forEach(ii => {
      if (ii.Id === i.SelectedLegalEntityId) {
        if (ii.IsMain) item.legalId = ii.Id;
        let legal = legals.filter(iii => {
          return iii.type === 3 && iii.contragent === i.Id && iii.value === ii.Id;
        })[0];
        if (!legal) legals.push({
          type: 3,
          contragent: i.Id,
          value: ii.Id,
          label: ii.Name,
        });
      }
    });
    if (!item1) contragents.push(item);
  });
  let a = contragents.filter(i => {
    return i.type === 3
  });
  a.forEach(i => {
    if (!i.legalId) {
      i.legalId = legals.filter(j => {
        return j.type === 3 && j.contragent === i.value;
      })[0].value;
    }
  });
  val.PaymentsData.OrdersPayments.forEach(i => {
    let legal = val.PartnerContractorsData.Contragents.filter(ii => {
      return ii.RequestId === i.RequestId;
    })[0];
    let inp = Math.ceil((i.OrderPrice - i.OrderDebt) * 100) / 100;
    let out = Math.ceil((i.OrderDebt) * 100) / 100;
    requests.push({
      code: val.AgreementCode,
      type: 3,
      contragent: i.OperatorId,
      legal: legal.SelectedLegalEntityId,
      key: '3_' + i.OperatorId + '_' + legal.SelectedLegalEntityId + '_' + i.RequestId,
      name: i.RequestCode || i.RequestId,
      value: i.RequestId,
      sum: 0,
      bonus: 0,
      course: i.CourseToAgreement,
      currency: i.CurrencyId,
      AGCurrency: val.PaymentsData.AgreementCurrencyId,
      inp: inp > 0 ? inp : 0,
      out: out > 0 ? out : 0,
      operatorId: i.OperatorId,
    });
  });
  if (val.PaymentsData.ForReservationCenter && (val.PaymentsData.IsReservationCenter || val.PaymentsData.IsSubAgent)) {
    val.ReservationCenterContractorsData.Contragents.forEach(i => {
      let legal = i.LegalEntities.filter(j => {
        return j.Id === i.SelectedLegalEntityId;
      })[0];
      contragents.push({
        type: 7,
        value: i.Id,
        label: i.Name,
        allow: val.PaymentsData.IsReservationCenter && val.PaymentsData.AllowViewSubAgentData,
        hiddenClient: val.PaymentsData.ForReservationCenter && val.PaymentsData.IsReservationCenter,
        hiddenOperator: val.PaymentsData.ForReservationCenter && val.PaymentsData.IsSubAgent,
        legalId: i.SelectedLegalEntityId,
        operatorId: val.PartnerContractorsData.Contragents.length ? val.PartnerContractorsData.Contragents[0].Id : '',
      });
      legals.push({
        type: 7,
        contragent: i.Id,
        value: legal.Id,
        label: legal.Name,
      });
      let inp = 0;
      let out = 0;
      if (val.PaymentsData.IsReservationCenter) {
        inp = val.PaymentsData.ReservationCenterDebt;
        out = val.PaymentsData.ReservationCenterPayed;
      }
      if (val.PaymentsData.IsSubAgent) {
        inp = val.PaymentsData.ReservationCenterPayed;
        out = val.PaymentsData.ReservationCenterDebt;
      }
      inp = Math.ceil(inp * 100) / 100;
      out = Math.ceil(out * 100) / 100;
      requests.push({
        code: val.AgreementCode,
        type: 7,
        contragent: i.Id,
        legal: legal.Id,
        key: '2_' + i.Id + '_' + legal.Id,
        value: 0,
        name: '',
        sum: 0,
        bonus: 0,
        course: i.Course,
        currency: i.CurrencyID,
        AGCurrency: val.PaymentsData.AgreementCurrencyId,
        inp: inp > 0 ? inp : 0,
        out: out > 0 ? out : 0,
        operatorId: val.PartnerContractorsData.Contragents.length ? val.PartnerContractorsData.Contragents[0].Id : '',
      });
    })
  }
  ag.contragents = contragents;
  ag.load = false;
  ag.legals = legals;
  ag.requests = requests;
  ag.course = 1;
  ag.paymentFor = '';
  ag.startDate = val.ClientContractorsData.StartDate.Serialized;
  ag.country = val.ClientContractorsData.CountryName;
}
